import { render, staticRenderFns } from "./SupplierRightsAndObligationsInput.vue?vue&type=template&id=4bc0eac2&"
import script from "./SupplierRightsAndObligationsInput.vue?vue&type=script&lang=js&"
export * from "./SupplierRightsAndObligationsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/form/SupplierRightsAndObligationsInput.vue
// module id = null
// module chunks = 